import React from 'react';
export function CourseOverview() {
  const courseOverview = ['Introduction to Defensive Shooting', 'Basic Defensive Handgun Skills', 'Firearms and the Law: Possession, Ownership, and the use of Deadly Force', 'Strategies for Home Safety and Responding to a Violent Confrontation', 'Selecting a Handgun for Self-Defense', 'Sport Shooting Activities and Training Opportunities', 'Course Review and Examination'];
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-981">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-982">
        <div className="mb-12" data-id="element-983">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-984">
            Course Overview
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-985">
            <ol className="space-y-4" data-id="element-986">
              {courseOverview.map((section, index) => <li key={index} className="flex items-start gap-4" data-id="element-987">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm" style={{
                backgroundColor: 'rgba(30,61,47,0.08)',
                color: '#1e3d2f',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-988">
                    {['I', 'II', 'III', 'IV', 'V', 'VI', 'VII'][index]}
                  </div>
                  <span className="text-base text-gray-800 pt-1" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-989">
                    {section}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </div>;
}